import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import PersonaFi from "@/pages/PersonaFi";

export const Route = createFileRoute("/by/personaFi")({
  head: () => routeHead('AGAPE PersonaFi — AI-валідацыя персон', META_DESCRIPTIONS.personafi.by, '/by/personaFi'),
  component: PersonaFi,
});
